import { getAuth } from "firebase/auth";
import firebaseApp from "../firebase";

export const API_BASE = (
  process.env.REACT_APP_API_BASE || "https://myquest-server.onrender.com"
).replace(/\/+$/, "");

export class ApiError extends Error {
  constructor(message, status, retryAfter) {
    super(message);
    this.status = status;
    this.retryAfter = retryAfter;
  }
}

// Note: AuthContext spreads the Firebase user into a plain object (losing
// getIdToken), so always read the live user from the auth instance.
export async function serverFetch(path, { method = "GET", body } = {}) {
  const user = getAuth(firebaseApp).currentUser;
  if (!user) throw new ApiError("You are signed out. Please sign in again.", 401);
  const token = await user.getIdToken();

  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new ApiError("Could not reach the server. Check your connection and try again.", 0);
  }

  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    /* non-JSON body */
  }
  if (!res.ok) {
    const retryAfter = Number(data?.retryAfter) || Number(res.headers.get("Retry-After")) || undefined;
    throw new ApiError(friendlyMessage(res.status, data?.message, retryAfter), res.status, retryAfter);
  }
  return data;
}

function friendlyMessage(status, serverMsg, retryAfter) {
  if (status === 429)
    return `Too many requests. Please wait${retryAfter ? ` ${retryAfter} seconds` : " a moment"} and try again.`;
  if (status === 403) return "You do not have permission to do this (admin access required).";
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (status === 503)
    return "The mail service is temporarily unavailable. Please try again shortly.";
  return serverMsg || `Request failed (${status}).`;
}
